// extracted by mini-css-extract-plugin
export default {"socialContainer":"socialAuth-module__socialContainer__iAeWm","socialItem":"socialAuth-module__socialItem__gKw0J"};